module.exports = __webpack_public_path__ + "media/images/home/EatkOkraAdRectangle-983099fd2f7eb79a045a61ffe7fbab35.png";